module.exports = __webpack_public_path__ + "static/media/left_active.6a27497a.png";